import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ShoppingCartIcon } from 'lucide-react';
const buyers = [{
  name: 'Graciela M.',
  city: 'Rosario'
}, {
  name: 'Estela R.',
  city: 'Mendoza'
}, {
  name: 'Néstor B.',
  city: 'Tucumán'
}, {
  name: 'Silvia S.',
  city: 'Salta'
}, {
  name: 'Marcelo D.',
  city: 'Córdoba'
}, {
  name: 'Liliana F.',
  city: 'La Plata'
}, {
  name: 'Hernán T.',
  city: 'Mar del Plata'
}, {
  name: 'Claudia P.',
  city: 'Santa Fe'
}, {
  name: 'Gustavo G.',
  city: 'Neuquén'
}, {
  name: 'Verónica V.',
  city: 'Bahía Blanca'
}, {
  name: 'Raúl H.',
  city: 'San Juan'
}, {
  name: 'Mirta A.',
  city: 'Posadas'
}, {
  name: 'Fernando C.',
  city: 'Resistencia'
}, {
  name: 'Adriana K.',
  city: 'Paraná'
}, {
  name: 'Pablo N.',
  city: 'Río Gallegos'
}, {
  name: 'Beatriz O.',
  city: 'San Luis'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    setCurrentBuyer(randomBuyer);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextInterval = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
      setTimeout(showNextPopup, nextInterval);
    }, 5000);
  };
  return <AnimatePresence data-id="element-316">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] bg-white rounded-xl shadow-2xl border border-gray-100 p-4 flex items-center gap-4" data-id="element-317">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-318">
            <XIcon className="w-4 h-4" data-id="element-319" />
          </button>

          <div className="w-12 h-12 bg-brand-green/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-320">
            <ShoppingCartIcon className="w-6 h-6 text-brand-green" data-id="element-321" />
          </div>

          <div data-id="element-322">
            <p className="text-sm text-gray-800" data-id="element-323">
              <span className="font-bold" data-id="element-324">{currentBuyer.name}</span> de{' '}
              {currentBuyer.city}
            </p>
            <p className="text-xs font-bold text-brand-green mt-1" data-id="element-325">
              ¡Acaba de comprar su MegaPack!
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-326">Hace unos minutos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}